<template>
  <div class="acp-page">
    <template v-if="from!='introDetail'">
      <Header />
      <div id="block"></div>
      <Box1 />
    </template>
    <Box2 />
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6 />
    <Box7 />
    <Box8 />
    <Box9 />
    <Box10 />
    <Box11 />
    <Box12 />
    <pageRightFloat pageName="阿里云大数据ACP认证课"/>
    <Footer />
  </div>
</template>

<script>
import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
import Box1 from "./Box1.vue"
import Box2 from "./Box2.vue"
import Box3 from "./Box3.vue"
import Box4 from "./Box4.vue"
import Box5 from "./Box5.vue"
import Box6 from "./Box6.vue"
import Box7 from "./Box7.vue"
import Box8 from "./Box8.vue"
import Box9 from "./Box9.vue"
import Box10 from "./Box10.vue"
import Box11 from "./Box11.vue"
import Box12 from "./Box12.vue"
export default {
  name: '',
  components:{
    pageRightFloat,
    Header,
    Footer,
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box7,
    Box8,
    Box9,
    Box10,
    Box11,
    Box12
  },
  data() {
    return {
       from:'',//来源
    }
  },
   mounted() {
  
   this.from=this.getQueryString("from")
  },
  methods: {
    
  },
}
</script>
<style lang="scss">
body,html{
  overflow-x: hidden;
}

.van-toast{
  padding: 24px !important;
  max-width: 660px;
  border-radius: 18px !important;
  .van-toast__text{
    color: #fff;
    line-height: 32px !important;
    font-size: 28px !important;
  }
}
</style>
<style lang="scss" scoped>

#block {
  width: 100%;
  height: 88px;
}

::v-deep {
  // 模块标题
  
  .acp-title{
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #332114;
    line-height: 56px;
    text-align: center;
  }

  // 模块副标题1
  .acp-stitle{
    margin-top: 48px;
    position: relative;
    display: flex;
    justify-content: center;
    height: 52px;
    span{
      display: inline-block;
      font-family: PingFangSC-Semibold;
      font-size: 32px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 32px;
      letter-spacing: 0px;
      color: #ff7f00;
      position: relative;
      z-index: 2;
    }
    &:after{
      z-index: 1;
      content: "";
      position: absolute;
      bottom: 12px;
      left: 50%;
      transform: translateX(-50%);
      width: 266px !important;
      height: 12px;
      background-color: #ffd9b3;
    }
  }

  // 模块副标题2
  .acp-text{
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4E5969;
    line-height: 40px;
    margin-top: 18px;
    text-align: center;
  }
}
</style>